export default __webpack_public_path__ + "static/media/gallery-wip-neck-base_03.73d2296f.jpg";